import { CustomButton } from "@/components/custom/custom-button";
import CustomSearchInput from "@/components/custom/custom-search-input";
import { DataTable } from "@/components/custom/data-table";
import { useAllCommission } from "@/hooks/use-all-commission";
import { Box, Stack, styled } from "@mui/material";
import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { getCommissionsColumns } from "./_components/commission-column";
import CommissionDialog from "./_components/commission-dialog";
import {
  createCommission,
  updateCommission,
} from "@/services/pricing-config.service";

const RootWrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(3),
}));

const Card = styled(Box)(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: 12,
  padding: theme.spacing(2.5),
  backgroundColor: theme.palette.background.paper,
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(2),
}));

const Commissions = () => {
  const [searchParams] = useSearchParams();
  const searchValue = searchParams.get("search") || "";
  const currentPage = Number(searchParams.get("page") || 0);
  const pageSize = Number(searchParams.get("size") || 10);

  const queryParams = {
    page: currentPage,
    size: pageSize,
    search: searchValue,
  };

  const {
    data: commissions,
    isLoading,
    isError,
  } = useAllCommission(true, queryParams);
  const [newCommissionOpen, setNewCommissionOpen] = useState(false);
  const [editCommission, setEditCommission] = useState(null);

  const handleEditClick = (commission) => setEditCommission(commission);
  const handleEditClose = () => setEditCommission(null);

  return (
    <RootWrapper>
      <Card>
        <Stack
          direction="row"
          spacing={3}
          alignItems="center"
          justifyContent="space-between"
        >
          <Stack direction="row" spacing={3}>
            <CustomSearchInput
              paramKey="search"
              placeholder="Search commission..."
            />
          </Stack>

          <CustomButton
            onClick={() => setNewCommissionOpen(true)}
            isLoading={false}
            variantType="outline"
            sx={{ height: 35 }}
          >
            Add Commission
          </CustomButton>
        </Stack>

        <DataTable
          data={commissions?.data?.data ?? []}
          columns={getCommissionsColumns(handleEditClick)}
          isLoading={isLoading}
          isError={isError}
        />
      </Card>

      <CommissionDialog
        open={newCommissionOpen}
        onClose={() => setNewCommissionOpen(false)}
        mutationFn={createCommission}
      />

      <CommissionDialog
        open={Boolean(editCommission)}
        onClose={handleEditClose}
        commission={editCommission}
        mutationFn={(payload) =>
          updateCommission({ id: editCommission?.id, ...payload })
        }
      />
    </RootWrapper>
  );
};

export default Commissions;
